import React, { useContext, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from '@material-ui/core';
import DirectionsIcon from '@material-ui/icons/Directions';
import { I18nContext } from 'translations';

export default function ModalFrequentRoute({ open, setOpen, onConfirm }) {
  const { translate } = useContext(I18nContext);
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setName('');
    setNameError(false);
  };

  const handleSubmit = () => {
    if (!name.trim()) {
      setNameError(true);
      return;
    }
    onConfirm && onConfirm(name.trim());
    handleClose();
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle disableTypography className="text-center">
        <Typography variant="h5" color="primary">
          <DirectionsIcon style={{ fontSize: '60px' }} />
          <br />
          {translate('app.commonRoutes.saveRouteTitle')}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <TextField
          label={translate('app.commonRoutes.routeNamePlaceholder')}
          value={name}
          onChange={(e) => { setName(e.target.value); setNameError(false); }}
          fullWidth
          autoFocus
          required
          variant="outlined"
          size="small"
          error={nameError}
          helperText={nameError && translate('app.commonRoutes.routeNameRequired')}
        />
      </DialogContent>

      <DialogActions style={{ justifyContent: 'center', padding: '16px 24px' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          style={{ minWidth: 140 }}
        >
          {translate('save')}
        </Button>
        <Button onClick={handleClose}>
          {translate('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
